import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import { SearchStores, SearchStoresVariables } from "./types/SearchStores";

export const searchStores = gql`
  ${pageInfoFragment}
  query SearchStores(
    $after: String
    $first: Int!
    $query: String!
    $direction: OrderDirection!
    $field: TenantSortField!
    $status: SmopStatusEnum
    $brand: [ID]
  ) {
    search: tenants(
      after: $after
      first: $first
      filter: { search: $query, brandId: $brand }
      status: $status
      sortBy: { direction: $direction, field: $field }
    ) {
      edges {
        node {
          id
          legalName
          storeName
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchStores, SearchStoresVariables>(
  searchStores
);
